import { Quote } from "lucide-react";

const items = [
  {
    quote:
      "I am very excited for this season because I am a completely different pitcher than last year!",
    name: "Eli P.",
    role: "HS Sophomore • Massachusetts",
  },
  {
    quote:
      "I just want to thank you for helping me with my mechanics. I'm at a tryout for this new team and I just topped out at 86 mph after being at 82 a couple weeks ago!!!",
    name: "Christian L.",
    role: "HS Junior • Kansas",
  },
  {
    quote:
      "My pitching feels better than ever! Especially with those drills you sent me.",
    name: "Aiden T.",
    role: "HS Senior • California",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 px-6 md:px-10 bg-[#0a0a0a] border-t border-[#1a1a1a] overflow-hidden"
    >
      {/* Marquee headline */}
      <div className="absolute top-8 left-0 right-0 overflow-hidden opacity-[0.04] pointer-events-none">
        <div className="bham-marquee whitespace-nowrap font-display text-[14rem] leading-none">
          ATHLETES &nbsp;•&nbsp; ATHLETES &nbsp;•&nbsp; ATHLETES &nbsp;•&nbsp;
          ATHLETES &nbsp;•&nbsp;
        </div>
      </div>

      <div className="max-w-7xl mx-auto relative">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-[#eab308]" />
            <span className="font-condensed uppercase tracking-[0.25em] text-xs text-[#eab308]">
              In Their Words
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
            Velocity Up. Confidence
            <span className="text-[#eab308]"> Higher.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="group bg-[#141414] border border-[#2a2a2a] hover:border-[#eab308] transition-all p-7 md:p-8 flex flex-col"
            >
              <Quote className="text-[#eab308] mb-6" size={28} />
              <p className="text-neutral-200 text-base md:text-lg leading-relaxed mb-8 flex-1">
                "{t.quote}"
              </p>
              <div className="border-t border-[#2a2a2a] pt-4">
                <div className="font-condensed uppercase tracking-wider text-white">
                  {t.name}
                </div>
                <div className="text-xs text-neutral-500 font-condensed uppercase tracking-[0.2em] mt-1">
                  {t.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
